import { GridRowApi } from "@mui/x-data-grid-pro";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { CalculationHistoryProps } from "./types";

export interface ReplenishmentState {
  calculationHistory: CalculationHistoryProps[];
  records: number;
  rowsForShipment: GridRowApi[];
  activeTab: boolean;
}

export const initialState: ReplenishmentState = {
  calculationHistory: [],
  records: 0,
  rowsForShipment: [],
  activeTab: true,
};

export const replenishmentSlice = createSlice({
  name: "replenishment",
  initialState,
  reducers: {
    addCalculationHistory: (
      state: ReplenishmentState,
      action: PayloadAction<CalculationHistoryProps[]>
    ) => {
      state.calculationHistory = action.payload;
    },
    addRecords: (state: ReplenishmentState, action: PayloadAction<number>) => {
      state.records = action.payload;
    },

    addRowsForShipment: (
      state: ReplenishmentState,
      action: PayloadAction<GridRowApi[]>
    ) => {
      state.rowsForShipment = action.payload;
    },
    removeRowsFromShipment: (state: ReplenishmentState) => {
      state.rowsForShipment = [];
    },
    removeRowFromShipment: (
      state: ReplenishmentState,
      action: PayloadAction<number>
    ) => {
      state.rowsForShipment = state.rowsForShipment.filter(
        (item: any) => item.merchant_sku !== action.payload
      );
    },
    changeActiveTab: (
      state: ReplenishmentState,
      action: PayloadAction<boolean>
    ) => {
      state.activeTab = action.payload;
    },
    clearCalculationHistory: (state: ReplenishmentState) => {
      state.calculationHistory = [];
    },
  },
});

export const {
  addCalculationHistory,
  addRecords,
  addRowsForShipment,
  removeRowsFromShipment,
  removeRowFromShipment,
  changeActiveTab,
  clearCalculationHistory,
} = replenishmentSlice.actions;
